import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { showMutationError } from "utils/showMutationError";

export const useProcessNewMessages = (onSuccess) => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    /*
     * This was the one Healthlink mutation that let the global handler speak for it, so a
     * failed download said "An error occurred. Please try again." and then said the
     * caller's line on top of it — two toasts for one press, on six screens, neither of
     * them carrying the reason the backend had sent.
     */
    meta: { skipGlobalError: true },
    mutationFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/healthlink/common/process-messages`
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["staffLaboratoryResults"] });
      queryClient.invalidateQueries({ queryKey: ["unmatchedStaffLaboratoryResults"] });
      queryClient.invalidateQueries({ queryKey: ["staffRadiologyResults"] });
      queryClient.invalidateQueries({ queryKey: ["unmatchedStaffRadiologyResults"] });
      queryClient.invalidateQueries({ queryKey: ["staffCommonResults"] });
      queryClient.invalidateQueries({ queryKey: ["unmatchedStaffCommonResults"] });
      queryClient.invalidateQueries({ queryKey: ["patientLaboratoryResults"] });
      queryClient.invalidateQueries({ queryKey: ["patientRadiologyResults"] });
      queryClient.invalidateQueries({ queryKey: ["patientCommonResults"] });
      queryClient.invalidateQueries({ queryKey: ["vaccines"] });
      queryClient.invalidateQueries({ queryKey: ["allImmunisations"] });
      queryClient.invalidateQueries({ queryKey: ["healthlinkImmunisations"] });
      queryClient.invalidateQueries({ queryKey: ["healthlinkVaccines"] });
      queryClient.invalidateQueries({ queryKey: ["referralsList"] });
      queryClient.invalidateQueries({ queryKey: ["referralXml"] });
      queryClient.invalidateQueries({ queryKey: ["activeConsultationReferral"] });
      queryClient.invalidateQueries({ queryKey: ["activeConsultation"] });
      queryClient.invalidateQueries({ queryKey: ["mncmsInboundMessages"] });
      queryClient.invalidateQueries({ queryKey: ["mncmsOutboundMessages"] });
      onSuccess?.();
    },
    // Success is each caller's own wording — they are different screens doing different
    // things with the same endpoint. A failure is the same failure everywhere.
    onError: (error) =>
      showMutationError(
        error,
        "We couldn't download new messages from Healthlink. Please try again."
      ),
  });
};
